import React, { useState, useEffect } from "react";
import { getPaneIndex, getTimeInterval } from "../../../redux/constants";
import { Button, Select, Popover, Tooltip } from "antd";
import TicketTable from "./TicketTable";
import moment from "moment";
import { getCustomizedDate } from "../../../redux/constants";
//import { WidgetSixData } from "./WidgetSixData";
import { useDispatch, useSelector } from "react-redux";
import {
  setTicketWidgetLoader,
  setPreWidgetsData,
} from "../../../redux/actions/ApiCall";
import {
  setTicketOverviewInterval,
  setTicketOverviewRoleType,
  setTicketOverviewWidget1,
  setTicketOverviewWidget2,
} from "../../../redux/actions/ApiCall/apiCall";
import HighCharts from "../../utils/charts/HighCharts";
import TicketOverviewcards from "./TicketOverviewCards";
import { Excel } from "antd-table-saveas-excel";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import download from "../../../assets/Download_Icon1.svg";
import downloadWhite from "../../../assets/WhiteIcons/DownloadWhite_Icon1.svg";
import barChart from "../../../assets/WidgetMaker/bar-chart.svg";
import barChartwhite from "../../../assets/WidgetMaker/bar-chart-white.svg";
import gridChart from "../../../assets/WidgetMaker/grid-chart.svg";
import gridChartwhite from "../../../assets/WidgetMaker/grid-chart-white.svg";
import filterIcon from "../../../assets/filterIcon.svg";
import filterIconWhite from "../../../assets/WhiteIcons/filterIconWhite.svg";
import accoArrow from "../../../assets/acco_arrow-up.svg";
import refresh from "../../../assets/refresh.svg";
import refreshWhite from "../../../assets/WhiteIcons/refresh_white.svg";

import accoArrowWhite from "../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import { secondsToDhms } from "../../../redux/constants";
import uuid from "react-uuid";
//import { DownOutlined } from "@ant-design/icons";

const { Option } = Select;

const TicketWidget = ({
  name,
  description,
  data,
  graph_type,
  xAxis,
  yAxis,
  widget_id,
  widget_index,
  ticket_chart_type,
}) => {
  //const [isHovered, setIsHovered] = useState(false);
  const [widgetLevelName2, setWidgetLevelName2] = useState();
  const [widgetLevelName3, setWidgetLevelName3] = useState();
  const [widgetLevelName4, setWidgetLevelName4] = useState();

  const [level2, setLevel2] = useState();
  const [level3, setLevel3] = useState();
  //const [level4, setLevel4] = useState();

  const [channel, setChannel] = useState([]);
  const [current, setCurrent] = useState([]);
  const [summary, setSummary] = useState([]);
  const [agentData, setAgentData] = useState([]);
  const [csdData, setCsdData] = useState([]);
  const [brandTicket, setBrandTicket] = useState([]);

  const [optionList, setOptionList] = useState([]);

  const dispatch = useDispatch();
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);
  // const selectedDate = panes[index].duration;

  const authParams = useSelector((state) => state.Authentication.authParams);
  // let index1 = getPaneIndex(panes, activeKey);
  // const ormBrands = useSelector((state) => state.Orm.ormBrands);
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  // const brandlogicalgroup = useSelector(
  //   (state) => state.ApiCall.brandlogicalgroup?.data?.result
  // );
  const selectedBrands = panes[index]?.brands?.columns;

  // const ticketWidgetArray = useSelector((state) => state.Orm.ticketWidgetArray);
  // const ticketOffset = useSelector((state) => state.Orm.ticketOffset);

  const ticketInterval = useSelector(
    (state) => state.ApiCall.ticketOverviewInterval
  );
  const ticketRoleType = useSelector(
    (state) => state.ApiCall.ticketOverviewRoleType
  );

  const ticketWidget1 = useSelector(
    (state) => state.ApiCall.ticketOverviewWidget1
  );
  const ticketWidget2 = useSelector(
    (state) => state.ApiCall.ticketOverviewWidget2
  );
  const preTicketLoader = useSelector(
    (state) => state.apiCall.ticketWidgetLoader
  );

  const [showGrid, setShowGrid] = useState(true);
  const [showBar, setShowBar] = useState(false);

  const [selectedWidget, setSelectedWidget] = useState("CSD");
  const [numberData, setNumberData] = useState();
  const [graphLoader, setGraphLoader] = useState(false);

  //const [deValue, setDeValue] = useState(60);
  const [visible, setVisible] = useState(false);
  //const [filter, setfilter] = useState(false);
  // const [channelWisetime, setChannelWisetime] = useState({
  //   flr: 30,
  //   resolution: 240,
  // });

  // const [interval, setInterval] = useState(60);
  // const [roleType, setRoleType] = useState(-1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let getInterval = getTimeInterval(
      panes[index]?.duration ? panes[index]?.duration?.to : defaultDuration?.to,
      panes[index]?.duration
        ? panes[index]?.duration?.from
        : defaultDuration?.from
    );

    // dispatch(setTicketOverviewWidget1(getInterval?.defaultVal));
    // dispatch(setTicketOverviewWidget2(getInterval?.defaultVal));
    // dispatch(setTicketOverviewInterval(getInterval?.defaultVal));

    setOptionList(getInterval?.timeList);
  }, [panes]);

  useEffect(() => {
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let startdate = panes[index]?.duration?.from
      ? panes[index]?.duration?.from
      : defaultDuration?.from;
    let endDate = panes[index]?.duration?.to
      ? panes[index]?.duration?.to
      : defaultDuration?.to;
    let diffDay = moment(endDate).diff(moment(startdate), "day");

    if (widget_id === "tickets_overview_4") {
      let avg = [];
      Array.isArray(data?.data?.grid?.dataSource) &&
        data?.data?.grid?.dataSource?.forEach((d, i) => {
          if (data?.data?.grid?.dataSource?.length - 1 === i) {
            avg.push({
              ChannelName: <b>{d["Channel Name"]}</b>,
              OpenCount: <b>{d["Open Count"]}</b>,
              DirectlyClosed: <b>{d["Directly Closed"]}</b>,
              ReplyAndClosed: <b>{d["Reply and Closed"]}</b>,
              EscalatedAndClosed: <b>{d["Escalated and Closed"]}</b>,
              OnHold: <b>{d["On Hold"]}</b>,
              AwaitingFromCustomer: <b>{d["Awaiting from customer"]}</b>,
              TotalTicketCount: <b>{d["Total Ticket Count"]}</b>,
            });
          } else {
            avg.push({
              ChannelName: d["Channel Name"],
              OpenCount: d["Open Count"],
              DirectlyClosed: d["Directly Closed"],
              ReplyAndClosed: d["Reply and Closed"],
              EscalatedAndClosed: d["Escalated and Closed"],
              OnHold: d["On Hold"],
              AwaitingFromCustomer: d["Awaiting from customer"],
              TotalTicketCount: d["Total Ticket Count"],
            });
          }
        });
      setChannel(avg);
    }

    if (widget_id === "tickets_overview_7") {
      let avg = [];
      Array.isArray(data?.dataSource) &&
        data?.dataSource?.forEach((d) => {
          avg.push({
            AgentCSDBrandName: d["Agent Name"],
            UserRole: d["User Role"],
            TotalTicketsCount: d["Total Tickets Count"],
            SystemAssigned: d["System Assigned"],
            UserAssigned: d["User Assigned"],
            LoginStatus: d["Login Status"],
          });
        });
      setCurrent(avg);
    }

    if (widget_id === "tickets_overview_8") {
      let avg = [];
      Array.isArray(data?.grid?.dataSource) &&
        data?.grid?.dataSource?.forEach((d, i) => {
          if (data?.grid?.dataSource?.length - 1 === i) {
            avg.push({
              Duration: <b>{d["Duration"]}</b>,
              TotalTickets: <b>{d["Total Tickets"]}</b>,
              DirectlyClosed: <b>{d["Directly Closed"]}</b>,
              WithEscalation: <b>{d["With Escalation"]}</b>,
              WithoutEscalation: <b>{d["Without Escalation (FTR)"]}</b>,
              AwaitingFromCustomer: <b>{d["Awaiting From Customer"]}</b>,
              Open: <b>{d["Open"]}</b>,
              OnHold: <b>{d["On hold"]}</b>,
              PostRevertFromCSDUser: <b>{d["Post Revert From CSD/User"]}</b>,
              PendingWithBrandCSD: <b>{d["Pending With Brand/CSD"]}</b>,
            });
          } else {
            avg.push({
              Duration:
                diffDay >= 6 &&
                ticket_chart_type !== "W" &&
                ticket_chart_type !== "M" &&
                ticket_chart_type !== "Y" &&
                ticketInterval === "D"
                  ? moment(d["Duration"]).format("D MMM")
                  : diffDay >= 6 &&
                    ticket_chart_type !== "W" &&
                    ticket_chart_type !== "M" &&
                    ticket_chart_type !== "Y" &&
                    (ticketInterval === 60 ||
                      ticketInterval === 120 ||
                      ticketInterval === 180 ||
                      ticketInterval === 240 ||
                      ticketInterval === 360 ||
                      ticketInterval === 480 ||
                      ticketInterval === 720)
                  ? moment(d["Duration"]).format("D MMM H:mm")
                  : diffDay >= 6 && ticket_chart_type === "M"
                  ? moment(d["Duration"]).format("MMM YYYY")
                  : diffDay >= 6 &&
                    (ticket_chart_type === "W" || ticket_chart_type === "Y")
                  ? d["Duration"]
                  : diffDay <= 6 &&
                    ticket_chart_type !== "W" &&
                    ticket_chart_type !== "M" &&
                    ticket_chart_type !== "Y" &&
                    ticketInterval === "D"
                  ? moment(d["Duration"]).format("D MMM")
                  : diffDay <= 6 &&
                    ticket_chart_type !== "W" &&
                    ticket_chart_type !== "M" &&
                    ticket_chart_type !== "Y" &&
                    (ticketInterval === 60 ||
                      ticketInterval === 120 ||
                      ticketInterval === 180 ||
                      ticketInterval === 240 ||
                      ticketInterval === 360 ||
                      ticketInterval === 480 ||
                      ticketInterval === 720)
                  ? moment(d["Duration"]).format("D MMM H:mm")
                  : ticketInterval === "D" &&
                    moment(d["Duration"]).format("D MMM YYYY, H:mm:ss A"),
              TotalTickets: d["Total Tickets"],
              DirectlyClosed: d["Directly Closed"],
              WithEscalation: d["With Escalation"],
              WithoutEscalation: d["Without Escalation (FTR)"],
              AwaitingFromCustomer: d["Awaiting From Customer"],
              Open: d["Open"],
              OnHold: d["On hold"],
              PostRevertFromCSDUser: d["Post Revert From CSD/User"],
              PendingWithBrandCSD: d["Pending With Brand/CSD"],
            });
          }
        });
      setSummary(avg);
    }

    if (widget_id === "tickets_overview_9") {
      let avg = [];
      Array.isArray(data?.dataSource) &&
        data?.dataSource?.forEach((d, i) => {
          // if (i < 5) {
          avg.push({
            AgentSupervisorName: d["Agent/Supervisor Name"],
            TotalCount: d["Total Count"],
            Unactioned: d["Unactioned"],
            DirectlyClosed: d["Directly Closed"],
            ReplyAndClosed: d["Reply & Closed"],
            EscalatedAndClosed: d["Escalate & Closed"],
            EscalatedPendingWithCSD: d["Esaclated (Pending with CSD)"],
            EscalatedPendingWithBrand: d["Esaclated (Pending with Brand)"],
            CSDRevertedPendingwithAgent: d["CSD Reverted (Pending with Agent)"],
            KeptOnhold: d["Kept Onhold"],
            AwaitingInfoFromCustomer: d["Awaiting Info From Customer"],
            AcknowledgeByAgent: d["Acknowledge By Agent"],
            WorkingHourTAT: secondsToDhms(d["Working Hour TAT"])
              ? secondsToDhms(d["Working Hour TAT"])
              : 0,
            TotalTAT: secondsToDhms(d["Total TAT"])
              ? secondsToDhms(d["Total TAT"])
              : 0,
          });
          // }
        });
      setAgentData(avg);
    }

    if (widget_id === "tickets_overview_10") {
      let avg = [];
      Array.isArray(data?.dataSource) &&
        data?.dataSource?.forEach((d, i) => {
          // if (i < 5) {
          avg.push({
            CSDUserName: d["CSD User Name"],
            TotalCount: d["Total Count"],
            Unactioned: d["Unactioned"],
            ReplyToAgent: d["Reply To Agent"],
            EscalatedPendingWithBrand: d["Esaclated (Pending with Brand)"],
            BrandRevertedPendingWithCSD: d["Brand Reverted (Pending with CSD)"],
            KeptOnhold: d["Kept Onhold"],
          });
          // }
        });
      setCsdData(avg);
    }

    if (widget_id === "tickets_overview_11") {
      let avg = [];
      Array.isArray(data?.dataSource) &&
        data?.dataSource?.forEach((d, i) => {
          // if (i < 5) {
          avg.push({
            BrandUserName: d["Brand User Name"],
            TotalCount: d["Total Count"],
            Unactioned: d["Unactioned"],
            DirectlyClosed: d["Directly Closed"],
            ReplyAndClosed: d["Reply & Closed"],
            ReplyToCSD: d["Reply To CSD"],
            ReplyToAgent: d["Reply To Agent"],
            KeptOnhold: d["Kept Onhold"],
          });
          // }
        });
      setBrandTicket(avg);
    }
  }, [widget_id, panes]);

  useEffect(() => {
    if (widget_id === "tickets_overview_2") {
      let arr = [];
      data?.forEach((d) => {
        arr.push(d?.number_data[0]);
      });
      setNumberData(arr);
    }
  }, []);

  useEffect(() => {
    const timerLoader = setTimeout(() => {
      setGraphLoader(false);
    }, 0);

    return () => {
      clearTimeout(timerLoader);
    };
  }, [selectedWidget]);
  const chart__styles = {
    width: "100%",
    height: "450px",
  };

  const ChannelWiseTicket = [
    {
      title: <div className="line-height-normal">Channel Name</div>,
      dataIndex: "ChannelName",
      key: "1",
    },
    {
      title: <div className="line-height-normal">Open Ticket Count</div>,
      dataIndex: "OpenCount",
      key: "2",
    },
    {
      title: "Closed Ticket",
      children: [
        {
          title: <div className="line-height-normal">Directly Closed</div>,
          dataIndex: "DirectlyClosed",
          key: "3",
        },
        {
          title: <div className="line-height-normal">Reply and Closed</div>,
          dataIndex: "ReplyAndClosed",
          key: "4",
        },
        {
          title: <div className="line-height-normal">Escalated and Closed</div>,
          dataIndex: "EscalatedAndClosed",
          key: "5",
        },
      ],
    },
    {
      title: <div className="line-height-normal">On Hold</div>,
      dataIndex: "OnHold",
      key: "6",
    },
    {
      title: <div className="line-height-normal">Awaiting from customer</div>,
      dataIndex: "AwaitingFromCustomer",
      key: "7",
    },
    {
      title: <div className="line-height-normal">Total Ticket Count</div>,
      dataIndex: "TotalTicketCount",
      key: "8",
    },
  ];
  const ChannelWiseTicketForExport = [
    {
      title: "Channel Name",
      dataIndex: "ChannelName",
      key: "1",
    },
    {
      title: "Open Ticket Count",
      dataIndex: "OpenCount",
      key: "2",
    },
    {
      title: "Closed Ticket",
      children: [
        {
          title: "Directly Closed",
          dataIndex: "DirectlyClosed",
          key: "3",
        },
        {
          title: "Reply and Closed",
          dataIndex: "ReplyAndClosed",
          key: "4",
        },
        {
          title: "Escalated and Closed",
          dataIndex: "EscalatedAndClosed",
          key: "5",
        },
      ],
    },
    {
      title: "On Hold",
      dataIndex: "OnHold",
      key: "6",
    },
    {
      title: "Awaiting from customer",
      dataIndex: "AwaitingFromCustomer",
      key: "7",
    },
    {
      title: "Total Ticket Count",
      dataIndex: "TotalTicketCount",
      key: "8",
    },
  ];
  const CurrentTicketStatus = [
    {
      title: <div className="line-height-normal">Agent Name</div>,
      dataIndex: "AgentCSDBrandName",
      key: "1",
      sorter: (a, b) => a.AgentCSDBrandName.length - b.AgentCSDBrandName.length,
    },
    {
      title: <div className="line-height-normal">User Role</div>,
      dataIndex: "UserRole",
      key: "2",
      sorter: (a, b) => a.UserRole.length - b.UserRole.length,
    },
    {
      title: <div className="line-height-normal">Total Tickets Count</div>,
      dataIndex: "TotalTicketsCount",
      key: "3",
      sorter: (a, b) => a.TotalTicketsCount - b.TotalTicketsCount,
    },
    {
      title: <div className="line-height-normal">System Assigned</div>,
      dataIndex: "SystemAssigned",
      key: "4",
      sorter: (a, b) => a.SystemAssigned - b.SystemAssigned,
    },
    {
      title: <div className="line-height-normal">User Assigned</div>,
      dataIndex: "UserAssigned",
      key: "5",
      sorter: (a, b) => a.UserAssigned - b.UserAssigned,
    },
    {
      title: <div className="line-height-normal">Login Status</div>,
      dataIndex: "LoginStatus",
      key: "6",
      sorter: (a, b) => a.LoginStatus.length - b.LoginStatus.length,
    },
  ];

  const TicketStatusSummary = [
    {
      title: "Duration",
      dataIndex: "Duration",
      key: "1",
      sorter: (a, b) => a.Duration.length - b.Duration.length,
    },
    {
      title: <div className="line-height-normal">Total Tickets</div>,
      dataIndex: "TotalTickets",
      key: "2",
      sorter: (a, b) => a.TotalTickets - b.TotalTickets,
    },
    {
      title: <div className="line-height-normal">Directly Closed</div>,
      dataIndex: "DirectlyClosed",
      key: "3",
      sorter: (a, b) => a.DirectlyClosed - b.DirectlyClosed,
    },
    {
      title: "Reply & Closed",
      children: [
        {
          title: <div className="line-height-normal">With Escalation</div>,
          dataIndex: "WithEscalation",
          key: "4",
          sorter: (a, b) => a.WithEscalation - b.WithEscalation,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "8rem" }}>
              Without Escalation (FLR){" "}
              <Tooltip title="First time resolution" placement="bottom">
                <i className="fa fa-question-circle" />
              </Tooltip>
            </div>
          ),
          dataIndex: "WithoutEscalation",
          key: "5",
          sorter: (a, b) => a.WithoutEscalation - b.WithoutEscalation,
        },
      ],
    },
    {
      title: <div className="line-height-normal">Awaiting From Customer</div>,
      dataIndex: "AwaitingFromCustomer",
      key: "6",
      sorter: (a, b) => a.AwaitingFromCustomer - b.AwaitingFromCustomer,
    },
    {
      title: "Pending With Agent",
      children: [
        {
          title: "Unactioned",
          children: [
            {
              title: "Open",
              dataIndex: "Open",
              key: "7",
              sorter: (a, b) => a.Open - b.Open,
            },
            {
              title: (
                <div
                  className="line-height-normal"
                  style={{ minWidth: "5rem" }}
                >
                  On hold
                </div>
              ),
              dataIndex: "OnHold",
              key: "8",
              sorter: (a, b) => a.OnHold - b.OnHold,
            },
          ],
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "8rem" }}>
              Post Revert From CSD/User
            </div>
          ),
          dataIndex: "PostRevertFromCSDUser",
          key: "9",
          sorter: (a, b) => a.PostRevertFromCSDUser - b.PostRevertFromCSDUser,
        },
      ],
    },
    {
      title: <div className="line-height-normal">Pending With Brand/CSD</div>,
      dataIndex: "PendingWithBrandCSD",
      key: "10",
      sorter: (a, b) => a.PendingWithBrandCSD - b.PendingWithBrandCSD,
    },
  ];

  const TicketStatusSummary1 = [
    {
      title: "Duration",
      dataIndex: "Duration",
      key: "1",
      sorter: (a, b) => a.Duration.length - b.Duration.length,
    },
    {
      title: "Total Tickets",
      dataIndex: "TotalTickets",
      key: "2",
      sorter: (a, b) => a.TotalTickets - b.TotalTickets,
    },
    {
      title: "Directly Closed",
      dataIndex: "DirectlyClosed",
      key: "3",
      sorter: (a, b) => a.DirectlyClosed - b.DirectlyClosed,
    },
    {
      title: "Reply & Closed",
      children: [
        {
          title: "With Escalation",
          dataIndex: "WithEscalation",
          key: "4",
          sorter: (a, b) => a.WithEscalation - b.WithEscalation,
        },
        {
          title: "Without Escalation (FLR)",
          dataIndex: "WithoutEscalation",
          key: "5",
          sorter: (a, b) => a.WithoutEscalation - b.WithoutEscalation,
        },
      ],
    },
    {
      title: "Awaiting From Customer",
      dataIndex: "AwaitingFromCustomer",
      key: "6",
      sorter: (a, b) => a.AwaitingFromCustomer - b.AwaitingFromCustomer,
    },
    {
      title: "Pending With Agent",
      children: [
        {
          title: "Unactioned",
          children: [
            {
              title: "Open",
              dataIndex: "Open",
              key: "7",
              sorter: (a, b) => a.Open - b.Open,
            },
            {
              title: "On hold",
              dataIndex: "OnHold",
              key: "8",
              sorter: (a, b) => a.OnHold - b.OnHold,
            },
          ],
        },
        {
          title: "Post Revert From CSD/User",
          dataIndex: "PostRevertFromCSDUser",
          key: "9",
          sorter: (a, b) => a.PostRevertFromCSDUser - b.PostRevertFromCSDUser,
        },
      ],
    },
    {
      title: "Pending With Brand/CSD",
      dataIndex: "PendingWithBrandCSD",
      key: "10",
      sorter: (a, b) => a.PendingWithBrandCSD - b.PendingWithBrandCSD,
    },
  ];

  const AgentTicketStatus = [
    {
      title: "",
      children: [
        {
          title: (
            <div className="line-height-normal">Agent/Supervisor Name</div>
          ),
          dataIndex: "AgentSupervisorName",
          key: "1",
          sorter: (a, b) =>
            a.AgentSupervisorName.length - b.AgentSupervisorName.length,
        },
        {
          title: <div className="line-height-normal">Total Count</div>,
          dataIndex: "TotalCount",
          key: "2",
          sorter: (a, b) => a.TotalCount - b.TotalCount,
        },
        {
          title: "Unactioned",
          dataIndex: "Unactioned",
          key: "3",
          sorter: (a, b) => a.Unactioned - b.Unactioned,
        },
      ],
    },
    {
      title: "Actioned",
      children: [
        {
          title: <div className="line-height-normal">Directly Closed</div>,
          dataIndex: "DirectlyClosed",
          key: "4",
          sorter: (a, b) => a.DirectlyClosed - b.DirectlyClosed,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "8rem" }}>
              Reply and Closed
            </div>
          ),
          dataIndex: "ReplyAndClosed",
          key: "5",
          sorter: (a, b) => a.ReplyAndClosed - b.ReplyAndClosed,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "10rem" }}>
              Escalated and Closed
            </div>
          ),
          dataIndex: "EscalatedAndClosed",
          key: "6",
          sorter: (a, b) => a.EscalatedAndClosed - b.EscalatedAndClosed,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "12.5rem" }}>
              Escalated (Pending with CSD)
            </div>
          ),
          dataIndex: "EscalatedPendingWithCSD",
          key: "7",
          sorter: (a, b) =>
            a.EscalatedPendingWithCSD - b.EscalatedPendingWithCSD,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "12.5rem" }}>
              Escalated (Pending with Brand)
            </div>
          ),
          dataIndex: "EscalatedPendingWithBrand",
          key: "8",
          sorter: (a, b) =>
            a.EscalatedPendingWithBrand - b.EscalatedPendingWithBrand,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "15rem" }}>
              CSD Reverted (Pending with Agent)
            </div>
          ),
          dataIndex: "CSDRevertedPendingwithAgent",
          key: "9",
          sorter: (a, b) =>
            a.CSDRevertedPendingwithAgent - b.CSDRevertedPendingwithAgent,
        },
        {
          title: "Kept Onhold",
          dataIndex: "KeptOnhold",
          key: "10",
          sorter: (a, b) => a.KeptOnhold - b.KeptOnhold,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "12rem" }}>
              Awaiting Info From Customer
            </div>
          ),
          dataIndex: "AwaitingInfoFromCustomer",
          key: "11",
          sorter: (a, b) =>
            a.AwaitingInfoFromCustomer - b.AwaitingInfoFromCustomer,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "10rem" }}>
              Acknowledge By Agent
            </div>
          ),
          dataIndex: "AcknowledgeByAgent",
          key: "12",
          sorter: (a, b) => a.AcknowledgeByAgent - b.AcknowledgeByAgent,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "8rem" }}>
              Working Hour TAT
            </div>
          ),
          dataIndex: "WorkingHourTAT",
          key: "13",
          sorter: (a, b) => a.WorkingHourTAT - b.WorkingHourTAT,
        },
        {
          title: (
            <div className="line-height-normal" style={{ minWidth: "8rem" }}>
              Total TAT
            </div>
          ),
          dataIndex: "TotalTAT",
          key: "14",
          sorter: (a, b) => a.TotalTAT - b.TotalTAT,
        },
      ],
    },
  ];

  const CSDTicketStatus = [
    {
      title: "",
      children: [
        {
          title: <div className="line-height-normal">CSD User Name</div>,
          dataIndex: "CSDUserName",
          key: "1",
          sorter: (a, b) => a.CSDUserName.length - b.CSDUserName.length,
        },
        {
          title: <div className="line-height-normal">Total Count</div>,
          dataIndex: "TotalCount",
          key: "2",
          sorter: (a, b) => a.TotalCount - b.TotalCount,
        },
        {
          title: "Unactioned",
          dataIndex: "Unactioned",
          key: "3",
          sorter: (a, b) => a.Unactioned - b.Unactioned,
        },
      ],
    },
    {
      title: "Actioned",
      children: [
        {
          title: <div className="line-height-normal">Reply To Agent</div>,
          dataIndex: "ReplyToAgent",
          key: "4",
          sorter: (a, b) => a.ReplyToAgent - b.ReplyToAgent,
        },
        {
          title: (
            <div className="line-height-normal">
              Esaclated (Pending with Brand)
            </div>
          ),
          dataIndex: "EscalatedPendingWithBrand",
          key: "5",
          sorter: (a, b) =>
            a.EscalatedPendingWithBrand - b.EscalatedPendingWithBrand,
        },
        {
          title: (
            <div className="line-height-normal">
              Brand Reverted (Pending with CSD)
            </div>
          ),
          dataIndex: "BrandRevertedPendingWithCSD",
          key: "6",
          sorter: (a, b) =>
            a.BrandRevertedPendingWithCSD - b.BrandRevertedPendingWithCSD,
        },
        {
          title: <div className="line-height-normal">Kept Onhold</div>,
          dataIndex: "KeptOnhold",
          key: "7",
          sorter: (a, b) => a.KeptOnhold - b.KeptOnhold,
        },
      ],
    },
  ];

  const BrandTicketStatus = [
    {
      title: "",
      children: [
        {
          title: "Brand User Name",
          dataIndex: "BrandUserName",
          key: "1",
          sorter: (a, b) => a.BrandUserName.length - b.BrandUserName.length,
        },
        {
          title: "Total Count",
          dataIndex: "TotalCount",
          key: "2",
          sorter: (a, b) => a.TotalCount - b.TotalCount,
        },
        {
          title: "Unactioned",
          dataIndex: "Unactioned",
          key: "3",
          sorter: (a, b) => a.Unactioned - b.Unactioned,
        },
      ],
    },
    {
      title: "Actioned",
      children: [
        {
          title: "Directly Closed",
          dataIndex: "DirectlyClosed",
          key: "4",
          sorter: (a, b) => a.DirectlyClosed - b.DirectlyClosed,
        },
        {
          title: "Reply & Closed",
          dataIndex: "ReplyAndClosed",
          key: "5",
          sorter: (a, b) => a.ReplyAndClosed - b.ReplyAndClosed,
        },
        {
          title: "Reply To CSD",
          dataIndex: "ReplyToCSD",
          key: "6",
          sorter: (a, b) => a.ReplyToCSD - b.ReplyToCSD,
        },
        {
          title: "Reply To Agent",
          dataIndex: "ReplyToAgent",
          key: "7",
          sorter: (a, b) => a.ReplyToAgent - b.ReplyToAgent,
        },
        {
          title: "Kept Onhold",
          dataIndex: "KeptOnhold",
          key: "8",
          sorter: (a, b) => a.KeptOnhold - b.KeptOnhold,
        },
      ],
    },
  ];

  const handleChangeShowGrid = () => {
    setShowGrid(true);
    setShowBar(false);
  };

  const handleChangeShowBar = () => {
    setShowBar(true);
    setShowGrid(false);
  };

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  const handleChangeOption = (value, id, w_index) => {
    //const d = new Date();
    //let utcOffset = d.getTimezoneOffset();
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let indexes = {
      pane_index: index,
      section_index: null,
      panes: panes,
      widget_index: w_index,
    };

    let graphObject = {
      authParams: authParams,
      role_type: widget_id === "tickets_overview_8" && ticketRoleType,
      // filterObj: filter ? filter : null,
      brands: selectedBrands
        ? Array.isArray(selectedBrands)
          ? selectedBrands
          : [selectedBrands]
        : Allbrands,
      duration: panes[index]?.duration
        ? panes[index]?.duration
        : defaultDuration,
      widget_id: id,
      chart_type: typeof value === "string" ? value : null,
      interval: typeof value === "number" ? value : null,
      isBrandModified: selectedBrands ? true : false,
      benchmark_breach:
        data?.widget_id === "tickets_orm_6" ||
        data?.widget_id === "tickets_orm_7" ||
        data?.widget_id === "tickets_orm_12" ||
        data?.widget_id === "tickets_orm_26"
          ? value
          : null,
      is_modified_date: panes?.[index]?.is_modified_date
        ? panes?.[index]?.is_modified_date
        : false,
    };

    if (widget_id === "tickets_overview_1") {
      dispatch(setTicketOverviewWidget1(value));
    }
    if (widget_id === "tickets_overview_2") {
      dispatch(setTicketOverviewWidget2(value));
    }
    if (widget_id === "tickets_overview_8") {
      dispatch(setTicketOverviewInterval(value));
    }
    authParams?.category_id &&
      dispatch(setPreWidgetsData(graphObject, indexes));
  };

  const handleFilter = (role, id, w_index) => {
    // const d = new Date();
    // let utcOffset = d.getTimezoneOffset();
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let indexes = {
      pane_index: index,
      section_index: null,
      panes: panes,
      widget_index: w_index,
    };

    let graphObject = {
      authParams: authParams,
      role_type: role,
      brands: selectedBrands
        ? Array.isArray(selectedBrands)
          ? selectedBrands
          : [selectedBrands]
        : Allbrands,
      isBrandModified: selectedBrands ? true : false,
      duration: panes[index]?.duration
        ? panes[index]?.duration
        : defaultDuration,
      widget_id: id,
      chart_type: typeof ticketInterval === "string" ? ticketInterval : null,
      interval: typeof ticketInterval === "number" ? ticketInterval : null,
      benchmark_breach: null,
    };

    dispatch(setTicketOverviewRoleType(role));
    authParams?.category_id &&
      dispatch(setPreWidgetsData(graphObject, indexes));
  };

  const handleGridData = (value, id, w_index) => {
    if (id === "tickets_overview_9") {
      setPageSize(value);
      let avg = [];
      Array.isArray(data?.dataSource) &&
        data?.dataSource?.forEach((d, i) => {
          // if (i < value) {
          avg.push({
            AgentSupervisorName: d["Agent/Supervisor Name"],
            TotalCount: d["Total Count"],
            Unactioned: d["Unactioned"],
            DirectlyClosed: d["Directly Closed"],
            ReplyAndClosed: d["Reply & Closed"],
            EscalatedAndClosed: d["Escalate & Closed"],
            EscalatedPendingWithCSD: d["Esaclated (Pending with CSD)"],
            EscalatedPendingWithBrand: d["Esaclated (Pending with Brand)"],
            CSDRevertedPendingwithAgent: d["CSD Reverted (Pending with Agent)"],
            KeptOnhold: d["Kept Onhold"],
            AwaitingInfoFromCustomer: d["Awaiting Info From Customer"],
            AcknowledgeByAgent: d["Acknowledge By Agent"],
            WorkingHourTAT: secondsToDhms(d["Working Hour TAT"])
              ? secondsToDhms(d["Working Hour TAT"])
              : 0,
            TotalTAT: secondsToDhms(d["Total TAT"])
              ? secondsToDhms(d["Total TAT"])
              : 0,
          });
          // }
        });
      setAgentData(avg);
    }

    if (widget_id === "tickets_overview_10") {
      setPageSize(value);
      let avg = [];
      Array.isArray(data?.dataSource) &&
        data?.dataSource?.forEach((d, i) => {
          // if (i < value) {
          avg.push({
            CSDUserName: d["CSD User Name"],
            TotalCount: d["Total Count"],
            Unactioned: d["Unactioned"],
            ReplyToAgent: d["Reply To Agent"],
            EscalatedPendingWithBrand: d["Esaclated (Pending with Brand)"],
            BrandRevertedPendingWithCSD: d["Brand Reverted (Pending with CSD)"],
            KeptOnhold: d["Kept Onhold"],
          });
          // }
        });
      setCsdData(avg);
    }

    if (widget_id === "tickets_overview_11") {
      setPageSize(value);
      let avg = [];
      Array.isArray(data?.dataSource) &&
        data?.dataSource?.map((d, i) => {
          // if (i < value) {
          avg.push({
            BrandUserName: d["Brand User Name"],
            TotalCount: d["Total Count"],
            Unactioned: d["Unactioned"],
            DirectlyClosed: d["Directly Closed"],
            ReplyAndClosed: d["Reply & Closed"],
            ReplyToCSD: d["Reply To CSD"],
            ReplyToAgent: d["Reply To Agent"],
            KeptOnhold: d["Kept Onhold"],
          });
          // }
        });
      setBrandTicket(avg);
    }
  };

  // channel dropdown removed, because it does not have functionality
  // <div>
  //       <label className="mr-15 text-gray">Channels</label>
  //       <Select
  //         defaultValue="All"
  //         style={{
  //           width: "100%",
  //         }}
  //         onChange={(e) => handleChangeChannel(e)}
  //         notFoundContent="Channel List"
  //         className="ticketOverView"
  //         bordered={false}
  //         suffixIcon={
  //           <img
  //             src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
  //             alt="accoArrow"
  //             className="accordionArrow p-0"
  //           />
  //         }
  //         dropdownClassName={
  //           authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
  //         }
  //       >
  //         {/* <Option value="All">All</Option> */}
  //       </Select>
  // </div>

  const content = (
    <div className="p-15">
      <div>
        <label className="mr-15 text-gray">User Role</label>
        <Select
          defaultValue={ticketRoleType == "-1" ? "All" : ticketRoleType}
          style={{
            width: "100%",
          }}
          onChange={(e) => handleFilter(e, widget_id, widget_index)}
          bordered={false}
          className="ticketOverView"
          suffixIcon={
            <img
              src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
              alt="accoArrow"
              className="accordionArrow p-0"
            />
          }
          dropdownClassName={
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }
        >
          <Option value="-1">All</Option>
          <Option value="0">Agent</Option>
          <Option value="3">Supervisor</Option>
          <Option value="1">CSD</Option>
          <Option value="2">Brand</Option>
        </Select>
      </div>
    </div>
  );

  // const bgColorArray = [
  //   "#57E2CF",
  //   "#57AEE3",
  //   "#5568E0",
  //   "#8B56E3",
  //   "#E256AD",
  //   "#E35668",
  //   "#E38957",
  //   "#E2CF56",
  //   "#AEE357",
  //   "#68E357",
  // ];

  // const colorArray = [
  //   "#E35668",
  //   "#E38957",
  //   "#E2CF56",
  //   "#AEE357",
  //   "#68E357",
  //   "#57E2CF",
  //   "#57AEE3",
  //   "#5568E0",
  //   "#8B56E3",
  //   "#E256AD",
  // ];

  const handleExport = () => {
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let startdate = panes[index]?.duration?.from
      ? panes[index]?.duration?.from
      : defaultDuration?.from;
    let endDate = panes[index]?.duration?.to
      ? panes[index]?.duration?.to
      : defaultDuration?.to;
    let diffDay = moment(endDate).diff(moment(startdate), "day");

    if (widget_id === "tickets_overview_4") {
      let avg = [];
      Array.isArray(data?.data?.grid?.dataSource) &&
        data?.data?.grid?.dataSource?.forEach((d, i) => {
          avg.push({
            ChannelName: d["Channel Name"],
            OpenCount: d["Open Count"],
            DirectlyClosed: d["Directly Closed"],
            ReplyAndClosed: d["Reply and Closed"],
            EscalatedAndClosed: d["Escalated and Closed"],
            OnHold: d["On Hold"],
            AwaitingFromCustomer: d["Awaiting from customer"],
            TotalTicketCount: d["Total Ticket Count"],
          });
        });

      const excel = new Excel();
      excel
        .addSheet("test")
        .addColumns(ChannelWiseTicketForExport)
        .addDataSource(avg, {
          str2Percent: true,
        })
        .saveAs("Channel_Wise_Tickets.xlsx");
    }
    if (widget_id === "tickets_overview_8") {
      let avg = [];
      Array.isArray(data?.grid?.dataSource) &&
        data?.grid?.dataSource?.forEach((d, i) => {
          if (data?.grid?.dataSource?.length - 1 === i) {
            avg.push({
              Duration: d["Duration"],
              TotalTickets: d["Total Tickets"],
              DirectlyClosed: d["Directly Closed"],
              WithEscalation: d["With Escalation"],
              WithoutEscalation: d["Without Escalation (FTR)"],
              AwaitingFromCustomer: d["Awaiting From Customer"],
              Open: d["Open"],
              OnHold: d["On hold"],
              PostRevertFromCSDUser: d["Post Revert From CSD/User"],
              PendingWithBrandCSD: d["Pending With Brand/CSD"],
            });
          } else {
            avg.push({
              Duration:
                diffDay >= 6 &&
                ticket_chart_type !== "W" &&
                ticket_chart_type !== "M" &&
                ticket_chart_type !== "Y" &&
                ticketInterval === "D"
                  ? moment(d["Duration"]).format("D MMM")
                  : diffDay >= 6 &&
                    ticket_chart_type !== "W" &&
                    ticket_chart_type !== "M" &&
                    ticket_chart_type !== "Y" &&
                    (ticketInterval === 60 ||
                      ticketInterval === 120 ||
                      ticketInterval === 180 ||
                      ticketInterval === 240 ||
                      ticketInterval === 360 ||
                      ticketInterval === 480 ||
                      ticketInterval === 720)
                  ? moment(d["Duration"]).format("D MMM H:mm")
                  : diffDay >= 6 && ticket_chart_type === "M"
                  ? moment(d["Duration"]).format("MMM YYYY")
                  : diffDay >= 6 &&
                    (ticket_chart_type === "W" || ticket_chart_type === "Y")
                  ? d["Duration"]
                  : diffDay <= 6 &&
                    ticket_chart_type !== "W" &&
                    ticket_chart_type !== "M" &&
                    ticket_chart_type !== "Y" &&
                    ticketInterval === "D"
                  ? moment(d["Duration"]).format("D MMM")
                  : diffDay <= 6 &&
                    ticket_chart_type !== "W" &&
                    ticket_chart_type !== "M" &&
                    ticket_chart_type !== "Y" &&
                    (ticketInterval === 60 ||
                      ticketInterval === 120 ||
                      ticketInterval === 180 ||
                      ticketInterval === 240 ||
                      ticketInterval === 360 ||
                      ticketInterval === 480 ||
                      ticketInterval === 720)
                  ? moment(d["Duration"]).format("D MMM H:mm")
                  : ticketInterval === "D" &&
                    moment(d["Duration"]).format("D MMM YYYY, H:mm:ss A"),
              TotalTickets: d["Total Tickets"],
              DirectlyClosed: d["Directly Closed"],
              WithEscalation: d["With Escalation"],
              WithoutEscalation: d["Without Escalation (FTR)"],
              AwaitingFromCustomer: d["Awaiting From Customer"],
              Open: d["Open"],
              OnHold: d["On hold"],
              PostRevertFromCSDUser: d["Post Revert From CSD/User"],
              PendingWithBrandCSD: d["Pending With Brand/CSD"],
            });
          }
        });

      const excel = new Excel();
      excel
        .addSheet("test")
        .addColumns(TicketStatusSummary1)
        .addDataSource(avg, {
          str2Percent: true,
        })
        .saveAs("Ticket_Status_Summary.xlsx");
    }
  };
  const handleRefresh = (widgetId, widgetIndex) => {
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };
    let indexes = {
      pane_index: index,
      section_index: null,
      panes: panes,
      widget_index: widgetIndex,
    };
    let graphObject = {
      authParams: authParams,
      role_type: widgetId === "tickets_overview_8" && ticketRoleType,
      // filterObj: filter ? filter : null,
      brands: selectedBrands
        ? Array.isArray(selectedBrands)
          ? selectedBrands
          : [selectedBrands]
        : Allbrands,
      duration: panes[index]?.duration
        ? panes[index]?.duration
        : defaultDuration,
      widget_id: widgetId,
      chart_type: typeof ticketInterval === "string" ? ticketInterval : null,
      interval: typeof ticketInterval === "number" ? ticketInterval : null,
      isBrandModified: selectedBrands ? true : false,
      benchmark_breach: null,
    };
    dispatch(
      setTicketWidgetLoader({
        widget_id: widgetId,
        value: true,
      })
    );
    authParams?.category_id &&
      dispatch(setPreWidgetsData(graphObject, indexes));
  };

  return (
    <div className="portlet1 p-0 mb-15">
      <div className="border-bottom d-flex justify-content-between align-items-center border-color p-10">
        <div>
          <div className="portlet__title fontSize-16 font-weight500 w-100">
            {/* <i className="fa fa-arrows" /> */}
            {name}
          </div>
          <div className="text_regular-gray">{description}</div>
        </div>
        {name === "Current Duration Ticket Summary" && (
          <div>
            <Select
              showArrow={true}
              bordered={false}
              className="ticketOverView"
              suffixIcon={
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  alt="accoArrow"
                  className="accordionArrow p-0"
                />
              }
              defaultValue={ticketWidget1}
              style={{
                width: "100%",
              }}
              onChange={(e) => handleChangeOption(e, widget_id, widget_index)}
              value={ticketWidget1}
              dropdownClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
            >
              {Array.isArray(optionList) &&
                optionList?.map((list, i) => {
                  return (
                    <Option value={list} key={i}>
                      {(list === 60 && "1 hr") ||
                        (list === 120 && "2 hrs") ||
                        (list === 180 && "3 hrs") ||
                        (list === 240 && "4 hrs") ||
                        (list === 360 && "6 hrs") ||
                        (list === 480 && "8 hrs") ||
                        (list === 720 && "12 hrs") ||
                        (list === "D" && "Daily") ||
                        (list === "M" && "Monthly") ||
                        (list === "W" && "Weekly") ||
                        (list === "Y" && "Yearly")}
                    </Option>
                  );
                })}
            </Select>
          </div>
        )}

        {name === "Role Wise Ticket Summary" && (
          <div>
            <Select
              showArrow={true}
              bordered={false}
              className="ticketOverView"
              suffixIcon={
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  alt="accoArrow"
                  className="accordionArrow p-0"
                />
              }
              defaultValue={ticketWidget2}
              value={ticketWidget2}
              style={{
                width: "100%",
              }}
              onChange={(e) => handleChangeOption(e, widget_id, widget_index)}
              dropdownClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
            >
              {Array.isArray(optionList) &&
                optionList?.map((list, i) => {
                  return (
                    <Option value={list} key={i}>
                      {(list === 60 && "1 hr") ||
                        (list === 120 && "2 hrs") ||
                        (list === 180 && "3 hrs") ||
                        (list === 240 && "4 hrs") ||
                        (list === 360 && "6 hrs") ||
                        (list === 480 && "8 hrs") ||
                        (list === 720 && "12 hrs") ||
                        (list === "D" && "Daily") ||
                        (list === "M" && "Monthly") ||
                        (list === "W" && "Weekly") ||
                        (list === "Y" && "Yearly")}
                    </Option>
                  );
                })}
            </Select>
          </div>
        )}

        {name === "Channel wise tickets" && (
          <div className="channel_tabs">
            {showGrid && !showBar && (
              <Tooltip title="Download Excel">
                <Button
                  style={{ padding: "0.5rem 0.8rem", background: "var(--locobuzz-primary-bg-white)" }}
                  onClick={handleExport}
                  className="border border-color border-radius-4 cursor-pointer"
                >
                  <img
                    src={
                      authParams?.theme_type === "1" ? downloadWhite : download
                    }
                    alt="download"
                    style={{ maxHeight: "2rem" }}
                  />
                </Button>
              </Tooltip>
            )}{" "}
            <Button
              style={{ padding: "0.5rem 0.8rem" }}
              onClick={handleChangeShowGrid}
              className={`ml-1 border border-color border-radius-4 cursor-pointer ${
                showGrid ? "active" : ""
              }`}
            >
              <img
                src={
                  authParams?.theme_type === "1" ? gridChartwhite : gridChart
                }
                alt="gridChart"
                style={{ maxHeight: "1.8rem" }}
              />
            </Button>
            <Button
              style={{ padding: "0.5rem 0.8rem", background: "var(--locobuzz-primary-bg-white)" }}
              onClick={handleChangeShowBar}
              className={`ml-2 border border-color border-radius-4 cursor-pointer ${
                showBar ? "active" : ""
              }`}
            >
              <img
                src={authParams?.theme_type === "1" ? barChartwhite : barChart}
                alt="barChart"
                style={{ maxHeight: "1.8rem" }}
              />
            </Button>
          </div>
        )}

        {name === "Ticket Status Summary" && (
          <div className="d-flex align-items-center">
            <Select
              showArrow={true}
              bordered={false}
              className="ticketOverView"
              suffixIcon={
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  alt="accoArrow"
                  className="accordionArrow p-0"
                />
              }
              defaultValue={ticketInterval}
              value={ticketInterval}
              style={{
                width: "100%",
              }}
              onChange={(e) => handleChangeOption(e, widget_id, widget_index)}
              dropdownClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
            >
              {Array.isArray(optionList) &&
                optionList?.map((list, i) => {
                  return (
                    <Option value={list} key={i}>
                      {(list === 60 && "1 hr") ||
                        (list === 120 && "2 hrs") ||
                        (list === 180 && "3 hrs") ||
                        (list === 240 && "4 hrs") ||
                        (list === 360 && "6 hrs") ||
                        (list === 480 && "8 hrs") ||
                        (list === 720 && "12 hrs") ||
                        (list === "D" && "Daily") ||
                        (list === "M" && "Monthly") ||
                        (list === "W" && "Weekly") ||
                        (list === "Y" && "Yearly")}
                    </Option>
                  );
                })}
            </Select>
            <Popover
              content={content}
              title={null}
              trigger="click"
              visible={visible}
              onVisibleChange={handleVisibleChange}
              placement="bottomRight"
              overlayClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
            >
              <span
                className="border btn_Clear border-color border-radius-4 cursor-pointer text-gray ml-15 ant-btn"
                style={{ padding: "0.5rem 0.8rem" }}
              >
                <img
                  src={
                    authParams?.theme_type === "1"
                      ? filterIconWhite
                      : filterIcon
                  }
                  alt="filter Icon"
                  style={{ maxHeight: "2rem" }}
                />
              </span>
            </Popover>
            {summary?.length > 0 && data?.line !== "No Data Found" && (
              <Tooltip title="Download Excel">
                <Button
                  onClick={handleExport}
                  className="ml-2 btn_Clear border-color border-radius-4"
                  style={{ padding: "0.5rem 0.8rem" }}
                >
                  <img
                    src={
                      authParams?.theme_type === "1" ? downloadWhite : download
                    }
                    alt="download"
                    style={{ maxHeight: "2rem" }}
                  />
                </Button>
              </Tooltip>
            )}
            <Button
              className="ml-2 border-color btn_Clear border-radius-4 cursor-pointer"
              style={{ padding: "0.5rem 1rem" }}
              onClick={() => handleRefresh(widget_id, widget_index)}
            >
              <Tooltip title="Refresh">
                <img
                  src={authParams?.theme_type === "1" ? refreshWhite : refresh}
                  alt="refresh"
                  style={{ maxHeight: "1.5rem" }}
                />
              </Tooltip>
            </Button>
          </div>
        )}
        {(widget_id === "tickets_overview_5" ||
          widget_id === "tickets_overview_7") && (
          <Button
            className="ml-2 border-color btn_Clear border-radius-4 cursor-pointer"
            style={{ padding: "0.5rem 1rem" }}
            onClick={() => handleRefresh(widget_id, widget_index)}
          >
            <Tooltip title="Refresh">
              <img
                src={authParams?.theme_type === "1" ? refreshWhite : refresh}
                alt="refresh"
                style={{ maxHeight: "1.5rem" }}
              />
            </Tooltip>
          </Button>
        )}
        {widget_id === "tickets_overview_9" && (
          <div className="d-inline-flex">
            <Select
              defaultValue={5}
              style={{
                width: "100%",
              }}
              className="ticketOverView"
              onChange={(e) => handleGridData(e, widget_id, widget_index)}
              bordered={false}
              suffixIcon={
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  alt="accoArrow"
                  className="accordionArrow p-0"
                />
              }
              dropdownClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
            >
              <Option value={5}>5</Option>
              <Option value={10}>10</Option>
              <Option value={20}>20</Option>
              <Option value={30}>30</Option>
            </Select>
            <Button
              className="ml-2 border-color btn_Clear border-radius-4 cursor-pointer"
              style={{ padding: "0.5rem 1rem" }}
              onClick={() => handleRefresh(widget_id, widget_index)}
            >
              <Tooltip title="Refresh">
                <img
                  src={authParams?.theme_type === "1" ? refreshWhite : refresh}
                  alt="refresh"
                  style={{ maxHeight: "1.5rem" }}
                />
              </Tooltip>
            </Button>
          </div>
        )}

        {widget_id === "tickets_overview_10" && (
          <div className="d-inline-flex">
            <Select
              defaultValue={5}
              style={{
                width: "100%",
              }}
              className="ticketOverView"
              onChange={(e) => handleGridData(e, widget_id, widget_index)}
              bordered={false}
              suffixIcon={
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  alt="accoArrow"
                  className="accordionArrow p-0"
                />
              }
              dropdownClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
            >
              <Option value={5}>5</Option>
              <Option value={10}>10</Option>
              <Option value={20}>20</Option>
              <Option value={30}>30</Option>
            </Select>
            <Button
              className="border-color btn_Clear border-radius-4 ml-2 cursor-pointer"
              style={{ padding: "0.5rem 1rem" }}
              onClick={() => handleRefresh(widget_id, widget_index)}
            >
              <Tooltip title="Refresh">
                <img
                  src={authParams?.theme_type === "1" ? refreshWhite : refresh}
                  alt="refresh"
                  style={{ maxHeight: "1.5rem" }}
                />
              </Tooltip>
            </Button>
          </div>
        )}

        {widget_id === "tickets_overview_11" && (
          <div>
            <Select
              defaultValue={5}
              // style={{
              //   width: "10rem",
              // }}
              className="ticketOverView"
              onChange={(e) => handleGridData(e, widget_id, widget_index)}
              bordered={false}
              suffixIcon={
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  alt="accoArrow"
                  className="accordionArrow p-0"
                />
              }
              dropdownClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
            >
              <Option value={5}>5</Option>
              <Option value={10}>10</Option>
              <Option value={20}>20</Option>
              <Option value={30}>30</Option>
            </Select>
            <Button
              className="border-color btn_Clear border-radius-4 ml-2 cursor-pointer"
              style={{ padding: "0.5rem 1rem" }}
              onClick={() => handleRefresh(widget_id, widget_index)}
            >
              <Tooltip title="Refresh">
                <img
                  src={authParams?.theme_type === "1" ? refreshWhite : refresh}
                  alt="refresh"
                  style={{ maxHeight: "1.5rem" }}
                />
              </Tooltip>
            </Button>
          </div>
        )}
      </div>

      {/* Widget 3 */}
      {graph_type === "number" ? (
        <div className="p-0">
          <div className="row mr-0">
            <div className="col-12 col-md-12 widget_full pr-0">
              <TicketOverviewcards
                cardPosition="Top"
                cardsData={data ? data : []}
                graph_type={graph_type}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="pl-15 pr-15 pb-15">
          <div className="row widget_full">
            {/* widget 2 */}
            {graph_type === "line-number" && (
              <>
                {preTicketLoader?.widget_id === "tickets_overview_2" &&
                preTicketLoader?.value ? (
                  <div
                    className="loader text-center w-100"
                    style={{ height: "calc(100vh - 15.2rem)" }}
                  >
                    <div className="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="col-12 col-md-3 pl-0 pr-0 kpi__column--2">
                      <TicketOverviewcards
                        cardPosition="Left"
                        cardsData={numberData ? numberData : []}
                        setSelectedWidget={setSelectedWidget}
                        widget_id="tickets_overview_2"
                        selectedWidget={selectedWidget}
                        graph_type={graph_type}
                        setGraphLoader={setGraphLoader}
                      />
                    </div>
                    <div
                      className="col-12 col-md-9 pl-0 pr-0 kpi__column--9"
                      style={{ minHeight: "48rem" }}
                    >
                      {selectedWidget ? (
                        Array.isArray(data) &&
                        data?.map((d) => {
                          if (selectedWidget === d.name) {
                            return (
                              <>
                                {typeof d?.line === "string" ? (
                                  <>
                                    <div className="d-flex full_nodata align-items-center">
                                      <div className="w-100 text-center">
                                        <div className="Nodata_img mb-15">
                                          <img
                                            src={somethingWentWrong}
                                            alt="no data"
                                          />
                                        </div>
                                        <div className="text_regular-gray">
                                          No Data Found
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : graphLoader ? (
                                  <div
                                    className="loader text-center w-100"
                                    style={{ height: "48rem" }}
                                  >
                                    <div className="lds-ring">
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <HighCharts
                                      dashboard={true}
                                      single={d.line}
                                      style={chart__styles}
                                      yaxis={yAxis}
                                      xaxis={xAxis}
                                      type="line"
                                      id={uuid()}
                                      ticket_chart_type={ticket_chart_type}
                                      ticket_status_duration={ticketWidget2}
                                    />
                                  </>
                                )}
                              </>
                            );
                          } else return null;
                        })
                      ) : (
                        <>
                          {typeof data[0].line === "string" ? (
                            <>
                              <div className="d-flex full_nodata align-items-center">
                                <div className="w-100 text-center">
                                  <div className="Nodata_img mb-15">
                                    <img
                                      src={somethingWentWrong}
                                      alt="no data"
                                    />
                                  </div>
                                  <div className="text_regular">
                                    No Data Found
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : graphLoader ? (
                            <div
                              className="loader text-center w-100"
                              style={{ height: "45rem" }}
                            >
                              <div className="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <HighCharts
                                dashboard={true}
                                single={data[0].line}
                                style={chart__styles}
                                yaxis={yAxis}
                                xaxis={xAxis}
                                type="line"
                                id={uuid()}
                                ticket_chart_type={ticket_chart_type}
                                ticket_status_duration={ticketWidget2}
                              />
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
              </>
            )}

            {/* Widget 1 */}
            {graph_type === "bar-number" &&
              widget_id === "tickets_overview_1" && (
                <>
                  {preTicketLoader?.widget_id === "tickets_overview_1" &&
                  preTicketLoader?.value ? (
                    <>
                      <div
                        className="loader text-center w-100"
                        style={{ height: "calc(100vh - 15.2rem)" }}
                      >
                        <div className="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-12  p-0  ">
                        <TicketOverviewcards
                          cardPosition="Top"
                          widget_id={widget_id}
                          cardsData={data?.number_data ? data?.number_data : []}
                          graph_type={"number"}
                        />
                      </div>
                      <div className="col-12 p-0">
                        {typeof data?.data === "string" ? (
                          <>
                            <div className="d-flex full_nodata align-items-center">
                              <div className="w-100 text-center">
                                <div className="Nodata_img mb-15">
                                  <img src={somethingWentWrong} alt="no data" />
                                </div>
                                <div className="text_regular-gray">
                                  No Data Found
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <HighCharts
                              dashboard={true}
                              single={data?.data}
                              style={chart__styles}
                              yaxis={yAxis}
                              xaxis={xAxis}
                              stacked={true}
                              type="bar"
                              id={uuid()}
                              ticket_widget_id={widget_id}
                              ticket_chart_type={ticket_chart_type}
                              ticket_status_duration={ticketWidget1}
                            />
                          </>
                        )}
                      </div>
                    </>
                  )}
                </>
              )}

            {/* Widget 4 */}
            {widget_id === "tickets_overview_4" && graph_type === "bar" && (
              <div className="col-12">
                {channel?.length > 0 || typeof data?.data?.bar !== "string" ? (
                  <>
                    {showGrid && !showBar && (
                      <TicketTable
                        tableColumns={ChannelWiseTicket}
                        dataSource={channel}
                        widget_id={widget_id}
                      />
                    )}
                    {showBar && !showGrid && (
                      <>
                        <HighCharts
                          dashboard={true}
                          single={data?.data?.bar}
                          style={chart__styles}
                          yaxis={yAxis}
                          xaxis={xAxis}
                          stacked={true}
                          type="bar"
                          id={uuid()}
                          ticket_widget_id={widget_id}
                          ticket_chart_type={ticket_chart_type}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <div className="d-flex full_nodata align-items-center">
                      <div className="w-100 text-center">
                        <div className="Nodata_img mb-15">
                          <img src={somethingWentWrong} alt="no data" />
                        </div>
                        <div className="text_regular-gray-gray">
                          No Data Found
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}

            {widget_id === "tickets_overview_5" &&
              graph_type === "grid" &&
              (preTicketLoader?.widget_id === "tickets_overview_5" &&
              preTicketLoader?.value ? (
                <div className="col-12">
                  <div className="portlet1 p-0 mb-15 mt-15">
                    <div
                      className="loader text-center w-100"
                      style={{ height: "calc(100vh - 15.2rem)" }}
                    >
                      <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                widget_id === "tickets_overview_5" &&
                graph_type === "grid" && (
                  <div className="col-12">
                    <TicketTable
                      tableColumns={data?.level_1?.columns}
                      dataSource={data?.level_1?.dataSource}
                      widget_id={widget_id}
                      setWidgetLevelName={setWidgetLevelName2}
                      level="2"
                      setLevel={setLevel2}
                      setLevel3={setLevel3}
                    />
                    {/* level 2 */}
                    {level2 == "2" && (
                      <TicketTable
                        tableColumns={data?.level_2[widgetLevelName2]?.columns}
                        dataSource={data?.level_2[widgetLevelName2]?.dataSource}
                        widget_id={widget_id}
                        widgetLevelName={widgetLevelName3}
                        setWidgetLevelName={setWidgetLevelName3}
                        level="3"
                        setLevel={setLevel3}
                        setLevel3={setLevel3}
                        LevelTabletitle2={
                          data?.level_2[widgetLevelName2]?.title
                        }
                      />
                    )}
                    {/* level 3 */}
                    {level2 == "2" && level3 == "3" && (
                      <TicketTable
                        tableColumns={data?.level_3[widgetLevelName3]?.columns}
                        dataSource={data?.level_3[widgetLevelName3]?.dataSource}
                        widget_id={widget_id}
                        setWidgetLevelName={setWidgetLevelName4}
                        level="4"
                        setLevel={setLevel3}
                        setLevel3={setLevel3}
                        LevelTabletitle3={
                          data?.level_3[widgetLevelName3]?.title
                        }
                      />
                    )}
                  </div>
                )
              ))}

            {widget_id === "tickets_overview_6" && graph_type === "grid" && (
              <div className="col-12">
                <TicketTable
                  tableColumns={data?.level_1?.columns}
                  dataSource={data?.level_1?.dataSource}
                  widget_id={widget_id}
                  setWidgetLevelName={setWidgetLevelName2}
                  level="2"
                  setLevel={setLevel2}
                  setLevel3={setLevel3}
                />
                {/* level 2 */}
                {level2 == "2" && (
                  <TicketTable
                    tableColumns={data?.level_2[widgetLevelName2]?.columns}
                    dataSource={data?.level_2[widgetLevelName2]?.dataSource}
                    widget_id={widget_id}
                    widgetLevelName={widgetLevelName3}
                    setWidgetLevelName={setWidgetLevelName3}
                    level="3"
                    setLevel={setLevel3}
                    setLevel3={setLevel3}
                    LevelTabletitle2={data?.level_2[widgetLevelName2]?.title}
                  />
                )}
                {/* level 3 */}
                {level2 == "2" && level3 == "3" && (
                  <TicketTable
                    tableColumns={data?.level_3[widgetLevelName3]?.columns}
                    dataSource={data?.level_3[widgetLevelName3]?.dataSource}
                    widget_id={widget_id}
                    setWidgetLevelName={setWidgetLevelName4}
                    level="4"
                    setLevel={setLevel3}
                    LevelTabletitle3={data?.level_3[widgetLevelName3]?.title}
                  />
                )}
              </div>
            )}

            {widget_id === "tickets_overview_7" &&
              graph_type === "grid" &&
              (preTicketLoader?.widget_id === "tickets_overview_7" &&
              preTicketLoader?.value ? (
                <div className="col-12">
                  <div className="portlet1 p-0 mb-15 mt-15">
                    <div
                      className="loader text-center w-100"
                      style={{ height: "calc(100vh - 15.2rem)" }}
                    >
                      <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                widget_id === "tickets_overview_7" &&
                graph_type === "grid" && (
                  <div className="col-12">
                    {current?.length > 0 ? (
                      <TicketTable
                        tableColumns={CurrentTicketStatus}
                        dataSource={current}
                        widget_id={widget_id}
                      />
                    ) : (
                      <div className="d-flex full_nodata align-items-center">
                        <div className="w-100 text-center">
                          <div className="Nodata_img mb-15">
                            <img src={somethingWentWrong} alt="no data" />
                          </div>
                          <div className="text_regular-gray">No Data Found</div>
                        </div>
                      </div>
                    )}
                  </div>
                )
              ))}

            {widget_id === "tickets_overview_8" &&
              graph_type === "line-grid" &&
              (preTicketLoader?.widget_id === "tickets_overview_8" &&
              preTicketLoader?.value ? (
                <div
                  className="loader text-center w-100"
                  style={{ height: "calc(100vh - 15.2rem)" }}
                >
                  <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              ) : (
                <div className="col-12">
                  {typeof data?.line === "string" ||
                  typeof data?.grid === "string" ? (
                    <div className="d-flex full_nodata align-items-center">
                      <div className="w-100 text-center">
                        <div className="Nodata_img mb-15">
                          <img src={somethingWentWrong} alt="no data" />
                        </div>
                        <div className="text_regular-gray">No Data Found</div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <HighCharts
                        dashboard={true}
                        single={data?.line}
                        style={chart__styles}
                        yaxis={yAxis}
                        xaxis={xAxis}
                        type="line"
                        id={uuid()}
                        ticket_chart_type={ticket_chart_type}
                        ticket_status_duration={ticketInterval}
                      />
                      <div className="mt-15">
                        <TicketTable
                          tableColumns={TicketStatusSummary}
                          dataSource={summary}
                          widget_id={widget_id}
                        />
                      </div>
                    </>
                  )}
                </div>
              ))}

            {widget_id === "tickets_overview_9" &&
              graph_type === "grid" &&
              (preTicketLoader?.widget_id === "tickets_overview_9" &&
              preTicketLoader?.value ? (
                <div className="col-12">
                  <div className="portlet1 p-0 mb-15 mt-15">
                    <div
                      className="loader text-center w-100"
                      style={{ height: "calc(100vh - 15.2rem)" }}
                    >
                      <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                widget_id === "tickets_overview_9" &&
                graph_type === "grid" && (
                  <div className="col-12">
                    {agentData?.length > 0 ? (
                      <TicketTable
                        tableColumns={AgentTicketStatus}
                        dataSource={agentData}
                        widget_id={widget_id}
                        pageSize={pageSize}
                      />
                    ) : (
                      <div className="d-flex full_nodata align-items-center">
                        <div className="w-100 text-center">
                          <div className="Nodata_img mb-15">
                            <img src={somethingWentWrong} alt="no data" />
                          </div>
                          <div className="text_regular-gray">No Data Found</div>
                        </div>
                      </div>
                    )}
                  </div>
                )
              ))}

            {widget_id === "tickets_overview_10" &&
              graph_type === "grid" &&
              (preTicketLoader?.widget_id === "tickets_overview_10" &&
              preTicketLoader?.value ? (
                <div className="col-12">
                  <div className="portlet1 p-0 mb-15 mt-15">
                    <div
                      className="loader text-center w-100"
                      style={{ height: "calc(100vh - 15.2rem)" }}
                    >
                      <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                widget_id === "tickets_overview_10" &&
                graph_type === "grid" && (
                  <div className="col-12">
                    {csdData?.length > 0 ? (
                      <TicketTable
                        tableColumns={CSDTicketStatus}
                        dataSource={csdData}
                        widget_id={widget_id}
                        pageSize={pageSize}
                      />
                    ) : (
                      <>
                        <div className="d-flex full_nodata align-items-center">
                          <div className="w-100 text-center">
                            <div className="Nodata_img mb-15">
                              <img src={somethingWentWrong} alt="no data" />
                            </div>
                            <div className="text_regular-gray">
                              No Data Found
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )
              ))}

            {widget_id == "tickets_overview_11" && graph_type == "grid" && (
              <div className="col-12">
                {preTicketLoader?.value ? (
                  <div className="portlet1 p-0 mb-15 mt-15">
                    <div
                      className="loader text-center w-100"
                      style={{ height: "calc(100vh - 15.2rem)" }}
                    >
                      <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                ) : brandTicket?.length ? (
                  <TicketTable
                    tableColumns={BrandTicketStatus}
                    dataSource={brandTicket}
                    widget_id={widget_id}
                    pageSize={pageSize}
                  />
                ) : (
                  <div className="d-flex full_nodata align-items-center">
                    <div className="w-100 text-center">
                      <div className="Nodata_img mb-15">
                        <img src={somethingWentWrong} alt="no data" />
                      </div>
                      <div className="text_regular-gray">No Data Found</div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketWidget;
